export default {"src":"/_next/static/media/Equifax_1.d9a973b0.svg","height":80,"width":80};